import React, { useEffect } from "react";
import { useScrollLockContext } from "../../contexts/scrollLockContext";
import useFullScreenLoading, { FullScreenLoadingProps } from "../../hooks/useFullScreenLoading";


export const FullScreenLoadingBar = (props : FullScreenLoadingProps) => {
    return useFullScreenLoading(props);
}

export const CircularLoadingBar = (props : FullScreenLoadingProps) => {
    return (
        <div className="h-[40px] w-[40px] border-2 border-neutral-300 border-t-brand-primary-magenta animate-spin rounded-full"/>
    )
}

export function RectLoadingBar({ isLoading}: FullScreenLoadingProps) {
const [index, setIndex] = React.useState(0);
const xList = [0, 20, 40];

const [, { lockScroll, unlockScroll }] = useScrollLockContext();

useEffect(() => {
    if (isLoading === true) {
    const interval = setInterval(() => {
        setIndex((index) => (index + 1) % 3);
    }, 250);
    const scrollId = lockScroll?.({});

    return () => {
        unlockScroll?.({ activeElements: [scrollId] });
        clearInterval(interval);
    };
    }
}, [isLoading]);

return (  
    <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    >
    {xList.map((x, i) => {
        return (
        <rect
            key={i}
            x={x}
            y="20"
            width="8"
            height="8"
            fill={index === i ? "url(#paint0_linear_2493_41859)" : "#D9D9D9"}
        />
        );
    })}

    <defs>
        <linearGradient
        id="paint0_linear_2493_41859"
        x1="16"
        y1="20"
        x2="7.48271"
        y2="22.1921"
        gradientUnits="userSpaceOnUse"
        >
        <stop stopColor="#E100A3" />
        <stop offset="1" stopColor="#EA27C2" />
        </linearGradient>
    </defs>
    </svg>
)
}

export function RectSmallLoadingBar({ isLoading}: FullScreenLoadingProps) {
const [index, setIndex] = React.useState(0);
const xList = [0, 20, 40];

const [, { lockScroll, unlockScroll }] = useScrollLockContext();

useEffect(() => {
    if (isLoading === true) {
    const interval = setInterval(() => {
        setIndex((index) => (index + 1) % 3);
    }, 250);
    const scrollId = lockScroll?.({});

    return () => {
        unlockScroll?.({ activeElements: [scrollId] });
        clearInterval(interval);
    };
    }
}, [isLoading]);

return (
    <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        {xList.map((x, i) => {
        return (
            <rect
            key={i}
            x={x}
            y="20"
            width="16"
            height="16"
            fill={index === i ? "url(#paint0_linear_2493_41859)" : "#D9D9D9"}
            />
        );
        })}

        <defs>
        <linearGradient
            id="paint0_linear_2493_41859"
            x1="16"
            y1="20"
            x2="7.48271"
            y2="22.1921"
            gradientUnits="userSpaceOnUse"
        >
            <stop stopColor="#E100A3" />
            <stop offset="1" stopColor="#EA27C2" />
        </linearGradient>
        </defs>
    </svg>
)
}